import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { B400, N800, N200 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import React from 'react';
import { AvatarItemOption, TextWrapper } from './AvatarItemOption';
import { HighlightText } from './HighlightText';
import { SizeableAvatar } from './SizeableAvatar';
import { hasValue } from './utils';
export var UserOption = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(UserOption, _React$PureComponent);

  var _super = _createSuper(UserOption);

  function UserOption() {
    var _this;

    _classCallCheck(this, UserOption);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getPrimaryText", function () {
      var _this$props$user = _this.props.user,
          name = _this$props$user.name,
          publicName = _this$props$user.publicName,
          highlight = _this$props$user.highlight;
      var result = [/*#__PURE__*/React.createElement(TextWrapper, {
        key: "name",
        color: _this.props.isSelected ? token('color.text.selected', B400) : token('color.text.highEmphasis', N800)
      }, /*#__PURE__*/React.createElement(HighlightText, {
        highlights: highlight && highlight.name
      }, name))];

      if (hasValue(publicName) && name.trim() !== publicName.trim()) {
        result.push( /*#__PURE__*/React.createElement(React.Fragment, {
          key: "publicName"
        }, ' ', /*#__PURE__*/React.createElement(TextWrapper, {
          color: _this.props.isSelected ? token('color.text.selected', B400) : token('color.text.lowEmphasis', N200)
        }, "(", /*#__PURE__*/React.createElement(HighlightText, {
          highlights: highlight && highlight.publicName
        }, publicName), ")")));
      }

      return result;
    });

    _defineProperty(_assertThisInitialized(_this), "renderSecondaryText", function () {
      return _this.props.user.byline ? /*#__PURE__*/React.createElement(TextWrapper, {
        color: _this.props.isSelected ? token('color.text.selected', B400) : token('color.text.lowEmphasis', N200)
      }, _this.props.user.byline) : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "renderAvatar", function () {
      var _this$props = _this.props,
          _this$props$user2 = _this$props.user,
          avatarUrl = _this$props$user2.avatarUrl,
          name = _this$props$user2.name,
          status = _this$props.status;
      return /*#__PURE__*/React.createElement(SizeableAvatar, {
        appearance: "big",
        src: avatarUrl,
        presence: status,
        name: name
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getLozengeProps", function () {
      return typeof _this.props.user.lozenge === 'string' ? {
        text: _this.props.user.lozenge
      } : _this.props.user.lozenge;
    });

    return _this;
  }

  _createClass(UserOption, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(AvatarItemOption, {
        avatar: this.renderAvatar(),
        primaryText: this.getPrimaryText(),
        secondaryText: this.renderSecondaryText(),
        lozenge: this.getLozengeProps()
      });
    }
  }]);

  return UserOption;
}(React.PureComponent);